import { CatalogueService } from 'src/app/angularJS/services/catalogue/catalogue.service';
import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';
import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';
import { UserService } from 'src/app/angularJS/services/user/user.service';

export class CatalogueCopyController {
  public static $inject = [
    '$state',
    '$stateParams',
    '$rootScope',
    'catalogueService',
    'UserMessages',
    'ACTToolbarService',
    'userService',
    '$translate',
    'regexPatterns'
  ];

  public catalogue: InterACT.Interfaces.Catalogues.Catalogue;
  public catalogueCopy: InterACT.Interfaces.Catalogues.Catalogue;
  public currentLocale: string;
  public date: Date;
  public time: string;
  public selectedScheme: InterACT.Interfaces.Schemes.Scheme;

  constructor(
    private $state: ng.ui.IStateService,
    private $stateParams,
    private $rootScope,
    private catalogueService: CatalogueService,
    private UserMessages: UserMessagesService,
    private ActToolbarService: ACTToolbarService,
    private userService: UserService,
    private $translate: ng.translate.ITranslateService,
    private regexPatterns: string) {
    this.catalogue = <any>{};
    this.catalogueCopy = angular.copy($stateParams.sourceCatalogue);
    this.currentLocale = $translate.use();
    this.selectedScheme = userService.selectedScheme;
    this.date = new Date();
    this.regexPatterns = regexPatterns;
    this.time = undefined;
    this.activate();
  }

  public activate() {
    this.$rootScope.showSpinner = false;
    this.ActToolbarService.getToolbar('primary').then((toolbar) => {
      toolbar.setTitle('CATALOGUES');
    });
  }

  public copyCatalogue = () => {
    this.$rootScope.showSpinner = true;
    const schemeLink: any = {};
    schemeLink.abbreviation = this.selectedScheme.reference;
    schemeLink.link = '/schemes/' + this.selectedScheme.id;
    this.catalogue.scheme = schemeLink;

    const dateTime = this.date;
    if (this.time) {
      const time = this.time.split(':');
      dateTime.setHours(parseInt(time[0], 10), parseInt(time[1], 10));
    }
    this.catalogue.effectiveFrom = <any>(moment(dateTime).utc().format('YYYY-MM-DDTHH:mm') + 'Z');

    return this.catalogueService.getCatalogue(this.$stateParams.sourceCatalogue.id, {
      expand: true
    }).then((response) => {
      return this.catalogueService.copy(angular.extend(response, this.catalogue))
        .then(() => {
          this.$rootScope.showSpinner = false;
          this.UserMessages.showToast('TOAST_MESSAGE.CATALOGUE.COPIED');
          this.exitCopyCatalogue();
        });
    });
  }

  public exitCopyCatalogue = () => { this.$state.go('catalogues.list'); };

  public isSchemeValid = (value: string) => this.catalogueCopy.scheme.abbreviation !== value;
}